// extracted by mini-css-extract-plugin
export default {"emptyContainer":"emptyView_emptyContainer__XpyCr","emptyText":"emptyView_emptyText__ypQMR"};